import React from "react";
import { useNavigate } from "react-router-dom";

const ErrorPage = () => {
    const navivate = useNavigate();
    return (
        <div>
            <h1>Page Not Found</h1>
            <br />
            {/* <Link to="/">Go back to Home Page</Link> */}
            <button onClick={() => navivate("/")}>Home</button>
        </div>
    );
};

export default ErrorPage;
